import { Box, styled } from '@mui/material';
import { commonBorderLight } from 'themes';

export const StyledModalHeaderIconContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '36px',
  width: '36px',
  borderRadius: '100px',
  border: commonBorderLight,
}));
